import React from 'react';
import { func } from 'prop-types';
import { Button } from 'htlib-copy';

import './ActionButtons.scss';

const TAG_VALUES = [
  { label: 'No', value: 'no' },
  { label: '?', value: 'unknown' },
  { label: 'Yes', value: 'yes' },
];

function typeFromValue(value) {
  switch (value) {
    case 'yes':
      return 'success';
    case 'no':
      return 'danger';
    case 'unknown':
      return 'regular';

    default:
      throw new Error(`${value} tag value is not supported`);
  }
}

export default function ActionButtons({ sendCheck }) {
  return (
    <div className="ActionButtons">
      {TAG_VALUES.map(({ label, value }) => (
        <Button
          key={value}
          type={typeFromValue(value)}
          onClick={() => {
            sendCheck(value);
          }}
        >
          <p>{label}</p>
        </Button>
      ))}
    </div>
  );
}

ActionButtons.propTypes = {
  sendCheck: func.isRequired,
};
